(function () {
  const body = document.body;
  const navigation = document.getElementById("main-navigation");
  const toggles = document.querySelectorAll("[data-js-navigation-toggle]");
  const btnClose = navigation?.querySelector("[data-js-main-navigation-close]") || null;
  const menu = document.getElementById("main-navigation-primary-menu");

  if (!navigation || !menu) return;

  const mq = window.matchMedia("(max-width: 782px)");

  // Keep the dropdown panel pinned to the bottom of the header. The header's
  // height varies with viewport width — the legal disclaimer wraps to 1 or 2
  // lines, and the wrap point differs per GEO (SE/NO/DK/FI disclaimer text) —
  // so a static CSS `top` drifts. Measure it and expose it as a CSS variable
  // the panel consumes via calc(). Re-measure on resize (rAF-throttled), on
  // load, and after web fonts settle (Rubik changes the disclaimer height).
  const header = document.querySelector(".main-header");
  let headerHeightRaf = null;
  const updateHeaderHeight = () => {
    if (!header || headerHeightRaf) return;
    headerHeightRaf = requestAnimationFrame(() => {
      headerHeightRaf = null;
      document.documentElement.style.setProperty(
        "--tvk-main-header-height",
        header.offsetHeight + "px"
      );
      // Sticky ad rails (CDN-1654) sit under header + shortcuts menu.
      const shortcuts = document.querySelector(".shortcuts-menu-wrapper");
      document.documentElement.style.setProperty(
        "--tvk-shortcuts-menu-height",
        (shortcuts ? shortcuts.offsetHeight : 0) + "px"
      );
    });
  };
  updateHeaderHeight();
  window.addEventListener("resize", updateHeaderHeight);
  window.addEventListener("load", updateHeaderHeight);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHeaderHeight);
  }

  const getRootLis = () => Array.from(menu.children).filter((el) => el instanceof HTMLLIElement);
  const getDirectLink = (li) => Array.from(li.children).find((el) => el instanceof HTMLAnchorElement) || null;
  const getDirectSubMenu = (li) =>
    Array.from(li.children).find((el) => el instanceof HTMLElement && el.classList.contains("sub-menu")) || null;

  let activeRoot = null;

  // Restructure menu items: separate link text from dropdown toggle
  const restructureMenuItems = () => {
    const allMenuItems = menu.querySelectorAll("li.menu-item-has-children");
    
    allMenuItems.forEach((li) => {
      const link = Array.from(li.children).find((el) => el instanceof HTMLAnchorElement);
      if (!link) return;
      
      // Check if already restructured
      if (link.querySelector(".menu-link-text")) return;
      
      const linkText = link.textContent.trim();
      
      // Wrap text in span
      link.innerHTML = `<span class="menu-link-text">${linkText}</span>`;
      
      // Add dropdown toggle button
      const toggleBtn = document.createElement("button");
      toggleBtn.type = "button";
      toggleBtn.className = "menu-dropdown-toggle";
      toggleBtn.setAttribute("aria-label", "Toggle submenu");
      toggleBtn.setAttribute("aria-expanded", "false");
      link.appendChild(toggleBtn);
    });
  };

  // Initialize menu structure
  restructureMenuItems();

  const setToggleExpanded = (expanded) => {
    toggles.forEach((toggle) => {
      if (!(toggle instanceof HTMLElement)) return;
      toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
      toggle.setAttribute(
        "aria-label",
        expanded ? "Close menu" : "Open menu"
      );
    });
  };

  const showNavigation = () => {
    if (!mq.matches) return;
    navigation.dataset.visible = "true";
    navigation.dataset.open = "true";
    navigation.setAttribute("aria-hidden", "false");
    body.classList.add("no-scroll");
    setToggleExpanded(true);

  };

  const hideNavigation = () => {
    if (!mq.matches) return;
    navigation.dataset.open = "false";
    body.classList.remove("no-scroll");
    navigation.dataset.visible = "false";
    navigation.setAttribute("aria-hidden", "true");
    setToggleExpanded(false);
    resetMenuState();
  };

  const setActiveRoot = (li) => {
    getRootLis().forEach((rootLi) => {
      const isActive = rootLi === li;
      rootLi.setAttribute("data-active", isActive ? "true" : "false");
      // Update toggle button aria-expanded
      const link = getDirectLink(rootLi);
      if (link) {
        const toggle = link.querySelector(".menu-dropdown-toggle");
        if (toggle) {
          toggle.setAttribute("aria-expanded", isActive ? "true" : "false");
        }
      }
    });
    activeRoot = li;
  };

  const resetMenuState = () => {
    activeRoot = null;
    getRootLis().forEach((li) => li.removeAttribute("data-active"));
    // Also reset all nested expanded states
    menu.querySelectorAll("[data-expanded]").forEach((el) => el.removeAttribute("data-expanded"));
  };

  btnClose?.addEventListener("click", hideNavigation);

  toggles.forEach(toggle => {
    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      if (navigation.dataset.open === "true") {
        hideNavigation();
      } else {
        showNavigation();
      }
    });
  });

  // Helper function to get sub-menu from any li
  const getSubMenu = (li) => 
    Array.from(li.children).find((el) => el instanceof HTMLElement && el.classList.contains("sub-menu")) || null;

  // Handle clicks on menu items
  menu.addEventListener("click", (e) => {
    if (!mq.matches) return;
    const target = e.target instanceof Element ? e.target : null;
    if (!target) return;
    
    // Check if clicked on dropdown toggle button
    const toggleBtn = target.closest(".menu-dropdown-toggle");
    if (toggleBtn instanceof HTMLButtonElement) {
      e.preventDefault();
      e.stopPropagation();
      
      const link = toggleBtn.closest("a");
      if (!link) return;
      const li = link.parentElement;
      if (!(li instanceof HTMLLIElement)) return;
      
      const isRoot = li.parentElement === menu;
      const hasChildren = getSubMenu(li) instanceof HTMLElement;
      
      if (!hasChildren) return;
      
      if (isRoot) {
        // Root level: toggle active state
        const isActive = activeRoot === li;
        if (isActive) {
          resetMenuState();
          activeRoot = null;
          toggleBtn.setAttribute("aria-expanded", "false");
        } else {
          setActiveRoot(li);
          toggleBtn.setAttribute("aria-expanded", "true");
        }
      } else {
        // Nested level: toggle expanded state
        const isExpanded = li.getAttribute("data-expanded") === "true";
        if (isExpanded) {
          li.removeAttribute("data-expanded");
          toggleBtn.setAttribute("aria-expanded", "false");
        } else {
          // Close siblings at same level first
          const parentUl = li.parentElement;
          if (parentUl instanceof HTMLElement) {
            Array.from(parentUl.children).forEach((sibling) => {
              if (sibling instanceof HTMLLIElement && sibling !== li) {
                sibling.removeAttribute("data-expanded");
                const sibLink = getDirectLink(sibling);
                if (sibLink) {
                  const sibToggle = sibLink.querySelector(".menu-dropdown-toggle");
                  if (sibToggle) sibToggle.setAttribute("aria-expanded", "false");
                }
              }
            });
          }
          li.setAttribute("data-expanded", "true");
          toggleBtn.setAttribute("aria-expanded", "true");
        }
      }
      return;
    }
    
    // Check if clicked on link text (span.menu-link-text)
    const linkText = target.closest(".menu-link-text");
    if (linkText) {
      // Allow navigation - don't prevent default
      const link = linkText.closest("a");
      if (link) {
        hideNavigation();
      }
      return;
    }
    
    // If clicked on link but not on text or toggle, check if it has children
    const link = target.closest("a");
    if (link instanceof HTMLAnchorElement && menu.contains(link)) {
      const li = link.parentElement;
      if (li instanceof HTMLLIElement) {
        const hasChildren = getSubMenu(li) instanceof HTMLElement;
        // If has children and clicked outside text/toggle, prevent navigation
        if (hasChildren) {
          e.preventDefault();
        } else {
          // No children: navigate and close
          hideNavigation();
        }
      }
    }
  });

  // Close when tapping backdrop.
  navigation.addEventListener("click", (e) => {
    if (!mq.matches) return;
    const target = e.target instanceof Element ? e.target : null;
    if (!target) return;
    if (target.matches("[data-js-main-navigation-close]")) hideNavigation();
  });

  // If we resize to desktop, make sure it's closed.
  window.addEventListener("resize", () => {
    if (!mq.matches) {
      navigation.dataset.open = "false";
      navigation.dataset.visible = "false";
      navigation.setAttribute("aria-hidden", "true");
      body.classList.remove("no-scroll");
      setToggleExpanded(false);
      resetMenuState();
    }
  });
})();
